/**
 * Given an element, this function traverses the DOM upwards until it finds the overflowSet item container element
 *
 * @param element The base control element
 * @returns The sought parent element if found
 */
export function findParentItemByClass(
  element: HTMLElement | null,
  classname: string
): HTMLElement | null {
  return findParentElementByCondition(element, (el: Element) =>
    el.classList?.contains(classname)
  );
}

export function findParentElementByCondition(
  element: HTMLElement | null,
  checkCondition: (el: HTMLElement) => boolean
): HTMLElement | null {
  if (!element) {
    return null;
  }

  if (checkCondition(element)) {
    return element;
  }
  return findParentElementByCondition(element.parentElement, checkCondition);
}
